import React from "react"
import { Link } from "gatsby"
import Button from "./Button"
import { LinkDetect } from "utils/LinkDetect"

export default function CMSLink({
  url,
  target, 
  className, 
  children, 
  type="button",
  minWidth=true,
  onClick,
  ...props
}) {

  const link = url.indexOf("mailto:") >= 0 ? { url: url } :  LinkDetect(url)
  const onClickFunc = onClick ? onClick : () => {}

  if (url.charAt(0) === "/" || url.charAt(0) === "#") {
    if (type === "button") {
      return(
        <Button 
          as={Link}
          to={link.url}
          target={target ? target : '_self'}
          className={className}
          minWidth={minWidth}
          onClick={onClickFunc}
          {...props}
        >
          {children}
        </Button>
      )
    } else {
      return(
        <Link
          to={link.url}
          target={target ? target : '_self'}
          className={className}
          onClick={onClickFunc}
          {...props}
        >
          {children}
        </Link>
      )
    }
  } else {
    // external link use normal anchor tag
    if (type === "button") {
      return(
        <Button 
          as="a"
          href={link.url}
          target={target ? target : undefined} 
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          className={className}
          minWidth={minWidth}
          onClick={onClickFunc}
          {...props}
        >
          {children}
        </Button>
      )
    }
    else {
      return(
        <a 
          href={link.url} 
          target={target ? target : undefined} 
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          className={className}
          onClick={onClickFunc}
          {...props}
        >
          {children}
        </a>
      )
    }
  }
}